(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flower-industry-cart"] && !Shopify.designMode) return;
  try {
    
  const deliveryDate = document.querySelector('[data-delivery-date]');
  const deliverySlot = document.querySelector('[data-delivery-slot]');
  const recipientMessage = document.querySelector('[data-recipient-message]');
  const notifyCheckbox = document.querySelector('[data-notify-day-before]');
  const notifyHidden = document.querySelector('input[type="hidden"][name="attributes[Prévenir le destinataire par SMS la veille]"]');
  const notifyHint = document.querySelector('[data-notify-hint]');
  const checkoutError = document.querySelector('[data-checkout-error]');
  const parisClock = () => {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
    return { date: `${parts.year}-${parts.month}-${parts.day}`, hour: Number(parts.hour), minute: Number(parts.minute) };
  };
  const addDays = (iso, days) => {
    const date = new Date(`${iso}T12:00:00Z`);
    date.setUTCDate(date.getUTCDate() + days);
    return date.toISOString().slice(0, 10);
  };
  const sameDayCutoffHour = 4;
  const earliestDate = clock => clock.hour < sameDayCutoffHour ? clock.date : addDays(clock.date, 1);
  const isAllowed = (selected, clock) => /^\d{4}-\d{2}-\d{2}$/.test(selected) && selected >= earliestDate(clock);
  const updateSmsPreview = () => {
    if (!recipientMessage) return;
    const selectedDate = deliveryDate?.value;
    const dateLabel = selectedDate
      ? new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(`${selectedDate}T12:00:00Z`))
      : 'la date choisie';
    const slot = deliverySlot?.value || 'le créneau choisi';
    recipientMessage.value = `Une jolie surprise vous attend ! Elle vous sera livrée le ${dateLabel} entre ${slot}. — Flower Industry`;
  };
  const updateDayBeforeOption = () => {
    if (!notifyCheckbox || !deliveryDate) return;
    const currentDate = parisClock().date;
    const deliveryIsTodayOrEarlier = !deliveryDate.value || deliveryDate.value <= currentDate;
    notifyCheckbox.disabled = deliveryIsTodayOrEarlier;
    if (deliveryIsTodayOrEarlier) {
      notifyCheckbox.checked = false;
      if (notifyHidden) notifyHidden.value = 'Non';
      if (notifyHint) notifyHint.textContent = 'Cette option est disponible pour une livraison prévue à partir de demain.';
    } else if (notifyHint) {
      notifyHint.textContent = 'Notre équipe peut lui envoyer un message discret la veille de la livraison, sans révéler votre identité.';
    }
  };
  if (deliveryDate) {
    const cartForm = document.querySelector('#fic-cart');
    const checkDate = () => {
      const clock = parisClock();
      deliveryDate.min = earliestDate(clock);
      deliveryDate.setCustomValidity(deliveryDate.value && !isAllowed(deliveryDate.value, clock)
        ? 'Les commandes passées après 4 h sont proposées à partir du lendemain.'
        : '');
      return deliveryDate.checkValidity();
    };
    const initialClock = parisClock();
    if (deliveryDate.value && !isAllowed(deliveryDate.value, initialClock)) {
      deliveryDate.value = '';
    }
    checkDate();
    updateDayBeforeOption();
    updateSmsPreview();
    deliveryDate.addEventListener('change', () => {
      if (!checkDate()) deliveryDate.reportValidity();
      updateDayBeforeOption();
      updateSmsPreview();
    });
    cartForm?.addEventListener('submit', event => {
      if (event.submitter?.name !== 'checkout') return;
      const firstInvalid = cartForm.querySelector(':invalid');
      if (!checkDate() || firstInvalid) {
        event.preventDefault();
        if (checkoutError) {
          checkoutError.hidden = false;
          checkoutError.textContent = 'Complétez les informations manquantes et choisissez une date de livraison valide.';
        }
        const field = cartForm.querySelector(':invalid');
        field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        field?.reportValidity();
      }
    });
  }
  deliverySlot?.addEventListener('change', updateSmsPreview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flower-industry-home"] && !Shopify.designMode) return;
  try {
    
  const addedDialog = document.querySelector('.fi-added-dialog');
  document.querySelectorAll('.fi-bouquet-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Ajout en cours…';
      try {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Ajout impossible');
        const cartResponse = await fetch(root + 'cart.js');
        const cartData = await cartResponse.json();
        const cartCount = document.querySelector('.fi-cart span');
        if (cartCount) cartCount.textContent = cartData.item_count;
        if (addedDialog) addedDialog.showModal();
      } catch (error) {
        HTMLFormElement.prototype.submit.call(form);
      } finally {
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  });

  if (addedDialog) {
    const closeButton = addedDialog.querySelector('.fi-dialog-close');
    if (closeButton) closeButton.addEventListener('click', () => addedDialog.close());
    addedDialog.querySelectorAll('a[href^="#"]').forEach((link) => link.addEventListener('click', () => addedDialog.close()));
    addedDialog.addEventListener('click', (event) => {
      if (event.target === addedDialog) addedDialog.close();
    });
  }

  document.querySelectorAll('.fi-variant-form').forEach((form) => {
    const select = form.querySelector('.fi-size-select');
    const price = form.querySelector('.fi-selected-price');
    const delivery = form.parentElement.querySelector('[data-variant-delivery]');
    select.addEventListener('change', () => {
      const selectedOption = select.options[select.selectedIndex];
      price.textContent = selectedOption.dataset.price;
      if (delivery) delivery.textContent = selectedOption.dataset.free === 'true' ? 'Livraison offerte dès ce format' : 'Paris : 15 € · proche banlieue : 25 €';
    });
  });
  const menuButton = document.querySelector('.fi-menu-button');
  const nav = document.querySelector('.fi-nav');
  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const open = nav.classList.toggle('fi-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      nav.classList.remove('fi-open');
      menuButton.setAttribute('aria-expanded', 'false');
    }));
  }

  document.querySelectorAll('.fi-file-input').forEach((input) => {
    input.addEventListener('change', () => {
      const label = input.previousElementSibling;
      const labelText = label ? label.querySelector('span') : null;
      if (labelText && input.files && input.files[0]) labelText.textContent = input.files[0].name;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flower-industry-product"] && !Shopify.designMode) return;
  try {
    
  const variantSelect = document.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-product-price]');
  const mobilePrice = document.querySelector('[data-mobile-price]');
  const delivery = document.querySelector('[data-product-delivery]');
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const nextPrice = selectedOption.dataset.price;
      if (price) price.textContent = nextPrice;
      if (mobilePrice) mobilePrice.textContent = nextPrice;
      if (delivery) delivery.innerHTML = selectedOption.dataset.free === 'true' ? '<b>Livraison offerte dès ce format</b>' : '<b>Paris : 15 € · proche banlieue : 25 €</b><small>Le tarif exact dépend de l’adresse. Les destinations hors Île-de-France sont sur devis.</small>'; 
    });
  }
  document.querySelectorAll('.fip-thumbnails button').forEach((button) => {
    button.addEventListener('click', () => {
      const mainImage = document.querySelector('.fip-main-image');
      if (mainImage) mainImage.src = button.dataset.image;
    });
  });
  const scrollButton = document.querySelector('[data-scroll-buy]');
  if (scrollButton) scrollButton.addEventListener('click', () => document.querySelector('#fip-purchase').scrollIntoView({ behavior:'smooth' }));
  const productForm = document.querySelector('.fip-product-form');
  const dialog = document.querySelector('.fip-dialog');
  if (productForm && dialog) {
    productForm.addEventListener('submit', async (event) => {
      const page = document.querySelector('.fip-page');
      if (page && page.dataset.attention === 'true') return;
      event.preventDefault();
      const button = productForm.querySelector('.fip-add');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Ajout en cours…';
      try {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const response = await fetch(root + 'cart/add.js', { method:'POST', headers:{ Accept:'application/json' }, body:new FormData(productForm) });
        if (!response.ok) throw new Error('Ajout impossible');
        const cartResponse = await fetch(root + 'cart.js');
        const cartData = await cartResponse.json();
        const cartCount = document.querySelector('.fip-cart span');
        if (cartCount) cartCount.textContent = cartData.item_count;
        dialog.showModal();
      } catch (error) {
        HTMLFormElement.prototype.submit.call(productForm);
      } finally {
        button.disabled = false;
        button.textContent = original;
      }
    });
    const close = dialog.querySelector('.fip-dialog-close');
    if (close) close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
